goog.provide('el8.appchart.mgr.thirdpane');

goog.require('el8.appchart.layout');
goog.require('el8.appchart.letters.main');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.visitNote2.main');
goog.require('el8.appservice.notifier');
goog.require('el8.service.pageunload');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.consts');


/**
 * The legacy Visit Note used to be the only thing that could live in the third pane, so the
 * code to manage the legacy visit note predates this file and lives in appchart/mgr/notes.js.
 *
 * That module is fairly complicated, so despite its name, this module is actually
 * responsible for managing elements in the third-pane _besides_ the legacy visit note
 * (and their interactions with legacy visit notes through the note manager). However, the
 * new React visit note IS managed by this module.
 *
 * The legacy visit note's main.js also relies on this file to manage some listeners
 * related to the whole third pane.
 *
 * The main.js file for every client of the thirdpane mgr should provide externally
 * callable 'show' and 'close' functions.
 *  + 'show' is responsible for rendering the pane's contents
 *  + 'close' is responsible for saving the pane's contents, emptying its container,
      and then dispatching a call to the hidePane function in this module.
 * See letters/main.js for an example.
 */
el8.appchart.mgr.thirdpane = (function() {

    var that = {};

    var container = $('#third-pane-container');

    var isInit = false;
    var viewModeButtonBound = false;
    var threePaneChangeBound = false;

    /* These allow us to generically deal with different kinds of 3rd pane items. */
    var openItemMain = null; //constructor for specific pane - e.g., el8.appchart.letters.main
    var openItemType = null; //convenience string for checking the kind of pane that is open

    // openItemTypes defined here; this is also the string that will show in the
    // two-pane view to expand a collapsed pane
    var LETTER_TYPE = 'Letter';
    var VISIT_NOTE_2_TYPE = 'Visit Note';

    /* Every third pane type will need its own show<Type> function (e.g., showLetter).
     * These two functions handle shared work that all of them will have to do.
     *  + superShowBefore should be called before invoking openItemMain.show()
     *  + superShowAfter does work which assumes there is content in the third pane
     *     container, so it should be called after invoking openItemMain.show() */
    function superShowBefore() {
        if (!isInit) { init(); }

        //pretend like we actually manage the whole 3rd pane by delegating to the note mgr
        el8.appchart.mgr.notes.closeOpenVisitNote();

        el8.appchart.layout.showThirdPane();
        that.bindLayoutListenFn();
    }
    function superShowAfter() {
        el8.appchart.layout.triggerThreePaneChange();
        el8.app.pageLayout.addResizeListener(that.adjustSize);
        that.adjustSize();
    }

    function init() {
        if (isInit) { return; }
         // Listener for the fullscreen/halfscreen button
        if (!viewModeButtonBound) { that.setupViewModeButton(); }
         // Let the pane save / clean-up if someone accidentally closes the window
        el8.service.pageunload.add(function() { that.close(); });
        isInit = true;
    }

    function threePaneChangeFn(event, isThreePaneAvailable, viewMode) {
        var $trigger = $('#thirdpane-view-mode-trigger', container);
        if (isThreePaneAvailable) {
            $trigger.show();
            updateViewModeTrigger(viewMode);
        } else {
            $trigger.hide();
        }
    }

    function updateViewModeTrigger(viewMode) {
        var $trigger = $('#thirdpane-view-mode-trigger', container);
        if (viewMode === 'big') {
            $trigger.text('fullscreen');
        } else {
            $trigger.text('halfscreen');
        }
    }

    $.extend(that, {

        adjustSize: function() {
            if (openItemMain && openItemMain.adjustSize) {
                // support overriding adjustSize, in case a 3P is more than a header/content-elem/buttons
                openItemMain.adjustSize();
            } else {
                // third-pane-container's parent's height has already been calculated, so copy it
                container.height(container.parent().height());
                // then we set a height on content inside the container
                var $thirdPaneContent = $('.third-pane-content', container);
                var $optionsPane = $('.ui-dialog-optionspane', container);
                var contentPadding = $thirdPaneContent.outerHeight(true) - $thirdPaneContent.height();
                var optionsHeight = $optionsPane.is(':visible') ? $optionsPane.outerHeight(true) : 0;
                $thirdPaneContent.height(
                    container.outerHeight(true) -
                    $('.ui-dialog-buttonpane', container).outerHeight(true) -
                    optionsHeight -
                    $('.third-pane-header', container).outerHeight(true) -
                    contentPadding
                );
            }
        },

        getPaneName: function() {
            if (el8.appchart.mgr.notes.visitNoteIsShowing()) {
                return 'Visit Note';
            } else if (openItemType) {
                return openItemType;
            } else {
                return '';
            }
        },

        maximizeOpenItem: function() {
            if (el8.appchart.mgr.notes.visitNoteIsShowing()) {
                el8.appchart.mgr.notes.showVisitNote({forceExisting: true});
            } else if (!openItemMain) {
                return false;
            }
            return true;
        },

        attachToLetter: function(spec) {
            spec = spec || {};
            // Pretty sure attachToLetter only gets called from chart feed items.
            // If that changes, then we'll need to re-evaluate this
            spec.clickSource = 'Chart Feed';
            if (openItemType !== LETTER_TYPE) {
                // no letter is open so we'll have to open a new one
                el8.appservice.notifier.notify('Creating a new letter for the attachment');
                this.showLetter(spec);
            } else {
                var letterType = openItemMain.getLetterType();

                // first do a raw comparison of types
                var sameType = spec.type === letterType;
                var providerLetterTypes = [el8.util.consts.REFERRAL_LETTER, el8.util.consts.CONSULTANT_LETTER];

                if (!spec.enforceStrictTypeMatch && _.contains(providerLetterTypes, spec.type) && _.contains(providerLetterTypes, letterType)) {
                    // now we wanna treat provider letter and referral the same for this use case
                    sameType = true;
                }

                if (!sameType) {
                    // different kind of letter is open so we'll still have to open a new one
                    el8.appservice.notifier.notify('Creating a new '+spec.type+ ' letter for the attachment');
                    this.showLetter(spec);
                } else {
                    // correct kind of letter is already open - just add the new attachment
                    el8.appservice.notifier.notify('Adding the attachment to the open letter');
                    spec.doHighlight = true; // highlight these additions to the letter
                    openItemMain.addAttachments(spec);
                }
            }
        },

        setLetterContact: function(contactId, clickSource) {
            this.setGenericLetterContact(contactId, el8.util.consts.CONSULTANT_LETTER, clickSource);
        },

        setReferralLetterContact: function(contactId, clickSource) {
            this.setGenericLetterContact(contactId, el8.util.consts.REFERRAL_LETTER, clickSource);
        },

        setGenericLetterContact: function(contactId, letterType, clickSource) {
            // if we have a consultant letter open, with an empty toField, we can just set the contact
            if (openItemType === LETTER_TYPE &&
                openItemMain.getLetterType() === letterType &&
                !openItemMain.getForm().getVal('toField')) {
                    openItemMain.setPhysicianId(contactId);
            } else {
                // otherwise, we need to open a new letter
                this.showLetter({
                    type: letterType,
                    contactId: contactId,
                    clickSource: clickSource
                });
            }
        },

        useLetterTemplate: function(templateId) {
            if (this.isLetterOpen() &&
                    openItemMain.getLetterType() !== el8.util.consts.REFERRAL_LETTER) {
                openItemMain.useLetterTemplate(templateId);
            } else {
                this.showLetter({
                    templateId: templateId,
                    clickSource: 'template'
                });
            }
        },

        showLetter: function(spec) {
            spec = spec || {};
            if (!el8Globals.FEATURES.Letters) { return; } // make sure feature flag is on
            if (spec.type === el8.util.consts.PATIENT_LETTER && !el8Globals.FEATURES.PatientPortal) { return; }

            var forceOpenLetter = function(spec) { //does no safety checking
                superShowBefore();
                openItemType = LETTER_TYPE;
                openItemMain = el8.appchart.letters.main;
                openItemMain.show(spec);
                superShowAfter();
            };
            var kindlyOpenLetter = function(spec) { //saves whatever was already open
                openItemMain.close();
                forceOpenLetter(spec);
            };

            if (!openItemMain) { //nothing already open
                forceOpenLetter(spec);
                return;
            }

            switch (openItemType) {
                case LETTER_TYPE:
                    if (spec.letter) { //selected a particular letter from reqAct
                        el8.appservice.notifier.notify('Closing current letter and displaying requested letter...');
                        kindlyOpenLetter(spec);
                    } else if (spec.attachmentId || spec.attachmentIds || spec.autoAddToCareTeam) { //new letter to hold this attachment
                        kindlyOpenLetter(spec);
                    } else {
                        el8.uiwidget.confirm( //prompt the user if they really want to create another, blank letter
                            'There is a letter already open. Are you sure you want to open a new one?',
                            function() {
                                kindlyOpenLetter(spec);
                            }
                        );
                    }
                    break;
                case VISIT_NOTE_2_TYPE:
                    kindlyOpenLetter(spec);
                    break;
                default:
                    break;

            }
        },

        isLetterOpen: function() {
            return (openItemType === LETTER_TYPE);
        },

        isVisitNote2Open: function() {
            return (openItemType === VISIT_NOTE_2_TYPE);
        },

        /**
         * Open a `VisitNote2` in the third pane.
         * 
         * @param props - props to pass into the `VisitNote2` React component.
         * Note that `props.noteId` is **required**!
         */
        showVisitNote2: function (props) {
            if (!el8Globals.FEATURES.VisitNote2) return;

            if (openItemMain) {
                openItemMain.close();
            }

            superShowBefore();
            openItemType = VISIT_NOTE_2_TYPE;
            openItemMain = el8.appchart.visitNote2.main;
            openItemMain.show(props);
            superShowAfter();
        },

        setupViewModeButton: function() {
            // this bool is separate from isInit because visitNote can also call this function
            if (viewModeButtonBound) { return; }
            container.on('click', '#thirdpane-view-mode-trigger',  _.debounce(function() {
                var viewMode = el8.appchart.layout.toggleViewMode();
                updateViewModeTrigger(viewMode);
            }, el8.util.consts.DEFAULT_DURATION, true));
            viewModeButtonBound = true;
        },

        bindLayoutListenFn: function() {
            if (threePaneChangeBound) { return; }
            $(document).on('el8_threePaneChange', threePaneChangeFn);
            threePaneChangeBound = true;
        },

        unbindLayoutListenFn: function() {
            if (!threePaneChangeBound) { return; }
            $(document).unbind('el8_threePaneChange', threePaneChangeFn);
            threePaneChangeBound = false;
        },

        // this function gets called to make a 3P item save and close
        close: function() {
            if (!openItemMain) { return; }
            openItemMain.close();
            this.hidePane();
        },

        // this function is used by 3P items and internally to hide the physical pane
        hidePane: function() {
            el8.appchart.layout.hideThirdPane();
            this.unbindLayoutListenFn();
            el8.app.pageLayout.removeResizeListener(this.adjustSize);
            openItemMain = null;
            openItemType = null;
        }

    });

    return that;

})();
